import {INITIAL_STATE} from './state/CreateXLComplaint';
import * as createXLComplaintTypes from '../types/CreateXLComplaint';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case createXLComplaintTypes.SET_XL_COMPLAINT_PARAMS:
            return {
                ...action.params
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/CreateComplaint.js